import React,{useEffect, useState} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from "axios";
import {Link, useNavigate} from 'react-router-dom'
import {Form} from 'react-bootstrap';
import toast from 'react-hot-toast';
import '../../style/AuthStyle.css';
import { AutoComplete,SelectPicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { SERVER_API } from '../../fileWithConstants'
const AddFabric = () => {
const [fabricPhoto, setFabricPhoto] = useState("");
const navigate = useNavigate();
const [name, setName] = useState('');

const [category, setCategory] = useState([]);
const [selectedCategory, setSelectedCategory] = useState('');
const [supplier, setSupplier] = useState([]);
const [selectedSupplier, setSelectedSupplier] = useState('');
const [selectedDye, setSelectedDye] = useState('');
const [qty, setQty] = useState('');
const [supplierfbname, setSupplierfbname] = useState('');
const [arz, setArz] = useState('');
const [price, setPrice] = useState('');
const [fabrics, setFabrics] = useState([]);
const [allFabrics, setAllFabrics] = useState([]);
const [fabtype, setFabtype] = useState(0);
const [option, setOption] = useState('');
const [submitting, setSubmitting] = useState(false);
const [validated, setValidated] = useState(false);
const[fbExist, setFbExist] = useState('');
const [arzerror, setArzError] = useState("");

const handleSubmit = async (e) => {
  e.preventDefault();
  const form = e.currentTarget;

  if (!name) {
    setFbExist("Fabric name is required!");
    return;
  }

  try {
    setSubmitting(true);

    // ✅ Check if fabric name already exists
    const { data: checkData } = await axios.get(
      `${SERVER_API}/api/v1/fabric/get-fabric-data-by-name/${name}`
    );

    if (checkData?.success && checkData?.fabrics?.length > 0) {
      setFbExist("Fabric name already exist!");
      setSubmitting(false);
      return;
    }

    setFbExist("");

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setSubmitting(false);
      return;
    }

    // ✅ Create FormData directly (no compression)
    const formData = new FormData();
    formData.append("name", name);
    formData.append("supplierfbname", supplierfbname);
    formData.append("fabtype", fabtype);
    formData.append("category", selectedCategory);
    formData.append("supplier", selectedSupplier);
    formData.append("dyeable", selectedDye);
    formData.append("arz", arz);

    if (fabricPhoto) {
      formData.append("fabric_photo", fabricPhoto);
    }

    const { data } = await axios.post(
      `${SERVER_API}/api/v1/fabric/add-fabric`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    if (data?.success) {
      toast.success(data?.message);

      // ✅ Reset fields
      setName("");
      setSelectedCategory("");
      setSelectedSupplier("");
      setSelectedDye("");
      setSupplierfbname("");
      setArz("");
      setFabricPhoto("");

      navigate("/dashboard/fabric-list");
    } else {
      toast.error(data?.message);
    }
  } catch (error) {
    console.error("Upload failed:", error);
    toast.error("Something went wrong while adding fabric.");
  } finally {
    setSubmitting(false); // ✅ Always stop loading
  }
};


const getAllSupplier = async()=>{
  try {
    const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-all-supplier`);
    if(data?.success && data?.suppliers?.length>0){
      setSupplier(data?.suppliers)
    }
  } catch (error) {
    console.log(error)
  }
}

const getAllFabricCategory = async()=>{
  try {
    const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-category`);
    if(data?.success){
      setCategory(data?.category)
    }
  } catch (error) {
    console.log(error)
  }
}

const getAllFabric = async()=>{
  try {
    const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabricdata/0/0/1`);
    if(data?.success){
      const fb_main_arr = data?.fabrics;
      setAllFabrics(fb_main_arr);
      const fab_names = fb_main_arr.map((fab)=>fab.name)
      setFabrics(fab_names);
    }
  } catch (error) {
    console.log(error)
  }
}

const getFabricData = async(item)=>{
  if(item!==''){
    alert('Fabric name already exist, please try another name.')
  }
}

useEffect(()=>{
  getAllFabric();
  getAllFabricCategory();
  getAllSupplier();
},[])

const onFileChange = (e) => {
  setFabricPhoto(e.target.files[0]);
};

const cancelHandle = ()=>{
  navigate('/dashboard/fabric-list');
}

 const handleArzChange = (e) => {
    const val = e.target.value;
    if (/^\d{0,2}$/.test(val)) {
      setArz(val);

      // validation: must be exactly 2 digits
      if (val.length === 2) {
        setArzError("");
      } else {
        setArzError("Arz must be exactly 2 digits");
      }
    }
  };

  return (
    <Layout title={'Add Fabric'}>
     
  <div className='form-container'>
  <Form noValidate validated={validated} onSubmit={handleSubmit} encType="multipart/form-data" className='form-section'>
      <h4 className='title'>Add Fabric</h4>
      <div className='form-box'>

        <div className="mb-3">
          <label>Fabric Name (New)*</label>
          <AutoComplete data={fabrics} name='name'
          onChange={(value,e)=>{ setName(value); setFabtype(0); setOption(''); }} defaultValue="" onSelect={(item,e)=>getFabricData(item)} />
          <p className='text-danger text-bold'>{fbExist}</p>
          <input name="fabtype" value={fabtype} type="hidden" />
        </div>

        <div className="mb-3">
          <label>Fabric Name By Supplier</label>
          <input type="text" 
          className="form-control"
          value={supplierfbname}
          name='supplier_fbname'
          onChange={(e)=>setSupplierfbname(e.target.value)}
          required
           />
        </div>

      <div className="mb-3">
        <label>Choose Category*</label>
        <SelectPicker
          data={category.map(c => ({ label: c.name, value: c.id }))}
          value={selectedCategory}
          onChange={setSelectedCategory}
          placeholder="Select Category"
          style={{ width: '100%' }}
          searchable
          className={validated && !selectedSupplier ? 'rs-invalid' : ''}
        />
           {validated && !selectedCategory && (
          <div className="text-danger mt-1">Category is required</div>
        )}
      </div>

      
      
     
      <div className="mb-3">
        <label>Supplier*</label>
       <SelectPicker
          data={supplier.map(s => ({ label: s.code, value: s.v_id }))}
          value={selectedSupplier}
          onChange={setSelectedSupplier}
          placeholder="Select Supplier"
          style={{ width: '100%' }}
          searchable
          className={validated && !selectedSupplier ? 'rs-invalid' : ''}
        />
        {validated && !selectedSupplier && (
          <div className="text-danger mt-1">Supplier is required</div>
        )}
      </div>
      <div className="mb-3">
        <label>Dyeable*</label>
        <select value={selectedDye} required className="form-select form-control" readOnly={option} name='dyeable' onChange={(e)=>setSelectedDye(e.target.value)}>
          <option value={""}>--Select--</option>
          <option value={"1"}>Yes</option>      
          <option value={"0"}>No</option>      
        </select>
      </div>

      <div className="mb-3">
        <label>Picture Upload*</label>
       <input className="form-control" required name='fabric_photo' type="file" accept="image/png, image/jpg, image/jpeg" onChange={onFileChange}/>
      </div>

      <div className="mb-3">
          <label>Arz*</label>
          <input
            type="text"
            className={`form-control ${arzerror ? "is-invalid" : ""}`}
            value={arz}
            name="arz"
            onChange={handleArzChange}
            maxLength={2}
            style={{ width: "40px" }}
            required
          />
          {arzerror && <div className="invalid-feedback">{arzerror}</div>}
        </div>
      
      <div className='row'>
      <div className='col-6'>
        <button 
          type="submit" 
          className="btn btn-dark form-control col-md-1 mb-3"
          disabled={submitting}
        >
          {submitting ? "Adding..." : "Add"}
        </button>
      </div>

      <div className='col-6'> <button type="button" onClick={cancelHandle} className="btn btn-dark form-control">Back</button></div>
      </div>
      </div>  
          
      </Form>
  </div>
    </Layout>
  )
}

export default AddFabric
